import React from 'react';
import { Box } from "@interstate/components/Box";
import { Typography } from "@interstate/components/Typography";


function Default() {
    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}><Typography variant="body-md">Nothing to see here...</Typography></Box>
        </Box>
    );
}
export default Default;